import { Checkbox, Col, DatePicker, Form, Row, Select } from 'antd';
import CurrencySelect from 'components/CurrencySelect';
import useFormatMessage from 'hooks/useFormatMessage';
import useUser from 'hooks/useUser';
import React from 'react';
import { currencies } from 'shared/constants/currencies';
import { DataSourceType, LicenseInterval } from 'shared/services/prisma/types';
import { dayjs } from 'shared/utils/date';
import globalMessages from 'translations/messages';

const dataSourceIntervalOptions = {
  [DataSourceType.Website]: [LicenseInterval.Yearly, LicenseInterval.Monthly],
  [DataSourceType.Cx]: [LicenseInterval.Yearly],
};

const LicenseForm = ({ dataSource }) => {
  const $t = useFormatMessage();
  const { isSuperUser } = useUser();

  const disabledDate = (date) => !isSuperUser && dayjs(date).isBefore();

  const intervalOptions = [...dataSourceIntervalOptions[dataSource.type]];

  if (isSuperUser) {
    intervalOptions.push(LicenseInterval.Trial);
  }

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item label="Start date" name="startDate">
            <DatePicker disabledDate={disabledDate} allowClear={false} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="interval" label="Subscription">
            <Select options={intervalOptions.map(o => ({ value: o, label: $t(globalMessages[o.toLowerCase()]) }))} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="currency" label="Currency">
            <CurrencySelect currencies={currencies} />
          </Form.Item>
        </Col>
      </Row>
      {isSuperUser && (
      <Row gutter={[16, 16]}>
        {!dataSource.hubspotDealRecordId && (
        <Col span={8}>
          <Form.Item name="createHubspotDeal" valuePropName="checked">
            <Checkbox>Create Hubspot Deal</Checkbox>
          </Form.Item>
        </Col>
        )}
        {dataSource.owner && (
        <Col span={16}>
          <Form.Item name="orderConfirmation" valuePropName="checked">
            <Checkbox>
              Send order confirmation to data source owner
              {' '}
              {dataSource.owner.email}
            </Checkbox>
          </Form.Item>
        </Col>
        )}
      </Row>
      )}
    </>
  );
};

export default LicenseForm;
